import React from 'react'
import SignIn from './SignIn'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AnonymousSignIn from './AnonymousSignIn';

const CertificationPage = (props) => {
  const signInArea = css`
    display: ${props.display};
    h4 {
      margin: 0;
    }
    z-index: 99;
    position: absolute;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: #0808087a;
    .window {
      background-color: white;
      text-align: center;
      padding-top: 100px;
      margin: 200px auto;
      width: 500px;
      height: 300px;
    }
  `;
  return (
    <div css={signInArea}>
      <div className='window'>
        <h4>下のボタンからサインインしてください。</h4>
        <SignIn />
      </div>

      <AnonymousSignIn />
    </div>
  )
}

export default CertificationPage
